export const PendingChangesAuthorsNoticeTestIds = {
  NOTICE: 'pending-changes-authors.notice-label',
};
